import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ title, value, change, changeType, icon, trend }) => {
  const isPositive = changeType === 'positive';
  const isNegative = changeType === 'negative';

  return (
    <div className="bg-card rounded-lg p-6 border border-border shadow-sm hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <p className="text-sm font-medium text-muted-foreground mb-1">{title}</p>
          <h3 className="text-3xl font-bold text-foreground">{value}</h3>
        </div>
        <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name={icon} size={24} className="text-primary" />
        </div>
      </div>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Icon 
            name={isPositive ? 'TrendingUp' : isNegative ? 'TrendingDown' : 'Minus'} 
            size={16} 
            className={isPositive ? 'text-success' : isNegative ? 'text-error' : 'text-muted-foreground'}
          />
          <span className={`text-sm font-medium ${isPositive ? 'text-success' : isNegative ? 'text-error' : 'text-muted-foreground'}`}>
            {change}
          </span>
        </div>
        {trend && (
          <div className="flex items-center gap-1">
            {trend?.map((point, index) => (
              <div 
                key={index} 
                className="w-1 bg-primary/30 rounded-full"
                style={{ height: `${point}px` }}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MetricCard;